<template minapp='mpx' xlang='wxml'>
  <view class='radio-icon__container'>
    <es-icon name="circle" size="{{size}}" color="#D4D3D3" wx:if="{{!checked}}"/>
    <es-icon name="dot-circle" size="{{size}}" color="#1473ff" wx:else/>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    classes: [],
    componentName: 'radioCircle',
    props: {
      size: {
        type: Number,
        value: 18
      },
      checked: {
        type: Boolean,
        value: false
      }
    },
    computed: {
    },
    methods: {
    }
  })
</script>

<style lang='stylus' scoped>
  .radio-icon__container
    display inline-block
    display flex
</style>

<script name='json'>
  module.exports = {
    component: true,
    "usingComponents": {
      'es-icon': '@didi/es-mpx-ui/lib/icon',
    }
  }
</script>